export default "__VITE_ASSET__Cx6oA7yR__"